export default __webpack_public_path__ + "static/slideshow-1-403cf0c449fddfa794a4858425b9711a.jpg";